import script from "./UserProfilePhoto.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserProfilePhoto.vue?vue&type=script&setup=true&lang=ts"

import "./UserProfilePhoto.vue?vue&type=style&index=0&id=2b2fb0f6&lang=scss&scoped=true"

import exportComponent from "/var/www/braintreewellbeing.org/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b2fb0f6"]])

export default __exports__